export const SET_CITIES = "setCities";
export const SET_SELECTED_CITY = "setSelectedCity";
export const UPDATE_CITIES_FILTER_TEXT = "updateCitiesFilterText";
export const RESET_CITIES_STATE = "resetCities";
